import React from "react";
import PageWrapper from "./RoleAndPermission.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RoleTable from "components/rolesAndPermission/RoleTable";

const RoleAndPermission = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.roleAndPermission"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.roleAndPermission"
          }
        ]}
      />
      <div className="user-tbl">
        <RoleTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(RoleAndPermission);
